import { Box, Button } from '@chakra-ui/react';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactExport from 'react-export-excel';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import useStore from '../../../../store';
import getDepartmentLabel from '../../../../utils/getDepartmentLabel';
import getOfficeLabel from '../../../../utils/getOfficeLabel';
import c from '../../../../constant';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function ExportExcelOfficialsRank({ employees = [], ...props }) {
	const { t } = useTranslation();
	const { currentLang: lang } = useStore((state) => state.currentLang);

	const formatDateOrDash = (date) => {
		if (!date || !moment(date).isValid()) {
			return '-';
		}

		return moment(date).format('DD MMM YYYY');
	};

	const getRankDate = (employee, rank) => {
		const records = employee?.positionStatuses || [];

		const rankRecord = records.find((record) => record?.rank === rank);

		if (rankRecord?.dateOfLastRank) {
			return formatDateOrDash(rankRecord?.dateOfLastRank);
		}

		return '-';
	};

	const data = employees?.map((employee, index) => {
		const positionStatuses = employee?.positionStatuses || [];

		const statuedOfficerRecord =
			employee?.latestPositionStatus?.position === '7' ? employee?.latestPositionStatus : positionStatuses.find((record) => record?.position === '7');

		const statuedOfficerDate = statuedOfficerRecord?.dateOfLastPosition
			? formatDateOrDash(statuedOfficerRecord.dateOfLastPosition)
			: employee?.currentWorkingStatus?.currentWorkingStatusPosition === '7'
				? formatDateOrDash(employee?.currentWorkingStatus?.currentWorkingStatusDateOfChangePosition)
				: '-';

		return {
			number: index + 1,
			fullNameKhmer: employee?.fullName || '-',
			fullNameEnglish: employee?.fullNameLatin || '-',
			department: employee?.department ? t(getDepartmentLabel(employee?.department)) : '-',
			office: employee?.office ? t(getOfficeLabel(employee?.office)) : '-',
			gender: employee?.gender ? t(employee?.gender) : '-',
			dob: formatDateOrDash(employee?.dob),
			employmentDate: formatDateOrDash(employee?.createdAt),
			statuteOfficerDate: statuedOfficerDate,

			level2: getRankDate(employee, 'Level_2'),
			level3: getRankDate(employee, 'Level_3'),
			level4: getRankDate(employee, 'Level_4'),
			level5: getRankDate(employee, 'Level_5'),
			level6: getRankDate(employee, 'Level_6'),
			level7: getRankDate(employee, 'Level_7'),
		};
	});

	const now = moment().format(c.dateTimeFormat);
	const filename = lang === 'kh' ? `បញ្ជីឋានន្តរស័ក្តិមន្ត្រី_${now}` : `Officials_Rank_List_${now}`;

	return (
		<Box {...props}>
			<ExcelFile
				filename={filename}
				element={
					<Button
						leftIcon={<FontAwesomeIcon icon={faFileExcel} style={{ fontSize: 16 }} />}
						colorScheme="gray"
						variant="solid"
						size="sm"
						borderRadius={c.borderRadius}
						border="1px solid #bdc3c7"
					>
						{t('Export')}
					</Button>
				}
			>
				<ExcelSheet data={data} name={t('Officials Rank List')}>
					<ExcelColumn label={t('Number')} value="number" />

					<ExcelColumn label={t('Fullname (Khmer)')} value="fullNameKhmer" />

					<ExcelColumn label={t('Fullname (Latin)')} value="fullNameEnglish" />

					<ExcelColumn label={t('Department')} value="department" />

					<ExcelColumn label={t('Office')} value="office" />

					<ExcelColumn label={t('Gender')} value="gender" />

					<ExcelColumn label={t('Date of birth')} value="dob" />

					<ExcelColumn label={t('Date of Employment')} value="employmentDate" />

					<ExcelColumn label={t('Date as Statute Officer')} value="statuteOfficerDate" />

					<ExcelColumn label={t('ក្រមការ')} value="level2" />

					<ExcelColumn label={t('ក្រមការដើមខ្សែរ')} value="level3" />

					<ExcelColumn label={t('នាយក្រមការ')} value="level4" />

					<ExcelColumn label={t('អនុមន្រ្តីកម្រិត៣')} value="level5" />

					<ExcelColumn label={t('អនុមន្រ្តីកម្រិត២')} value="level6" />

					<ExcelColumn label={t('អនុមន្រ្តីកម្រិត១')} value="level7" />
				</ExcelSheet>
			</ExcelFile>
		</Box>
	);
}
